import { SegmentedControl } from "@mantine/core";
import type { AnalyticsPeriod } from "../types";

interface PeriodFilterProps {
  period: AnalyticsPeriod;
  onChange: (period: AnalyticsPeriod) => void;
}

export const PeriodFilter = ({ period, onChange }: PeriodFilterProps) => {
  return (
    <SegmentedControl
      value={period}
      onChange={(value) => onChange(value as AnalyticsPeriod)}
      data={[
        { label: "All Time", value: "all" },
        { label: "This Month", value: "month" },
        { label: "This Week", value: "week" },
        { label: "Today", value: "day" },
      ]}
    />
  );
};
